<section class="section banner">
  <div [@bannerTrigger] class="container">
    <div class="section-box-banner">
      <div class="content">
        <div class="banner-pre">
          <div class="banner-title">
            <h2 class="banner-title">Hi! I'm Stefan.</h2>
          </div>
          <div class="banner-description">
            <p [innerHTML]="'Banner.Description' | translate" class="mt-4"></p>
          </div>
        </div>
      </div>
      <div class="div-btn-banner">
        <a
          href="mailto:juca_stefan_florin@yahoo.com"
          target="_black"
          class="main-btn"
        >
          {{ "Banner.ActionBtn" | translate }}
        </a>
      </div>
    </div>
  </div>
</section>
